/* eslint-disable @typescript-eslint/no-unused-vars */
import { Action } from '@reduxjs/toolkit';
import { Epic, StateObservable, ofType } from 'redux-observable';
import { Observable, catchError, concatMap, from, map, of } from 'rxjs';

import { Dependencies } from '@configurations/dependencies/dependencies';
import { RootState } from '@store/create-store';
import { WeatherYear } from '@scenario/models/weather-year.model';
import { retrieveWeatherYearsFailure, retrieveWeatherYearsSuccess } from '@store/scenario/weather-years/weather-years-slice';

export const retrieveWeatherYearsEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('weatherYears/retrieveWeatherYears'),
    concatMap((_action: Action) =>
      from(dependencies.weatherYearGateway.retrieveAll()).pipe(
        map((weatherYears: WeatherYear[]) => retrieveWeatherYearsSuccess(weatherYears)),
        catchError(() => of(retrieveWeatherYearsFailure('Fail to retrieve weather years'))),
      ),
    ),
  );
